import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteItem, resetCart, decreseQuantity, increseQuantity } from '../redux/amazonSlice';
import { Link } from 'react-router-dom';
import { emptyCart } from '../assets/index';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Cart =()=> {
    const dispatch = useDispatch();
    //useSelector hook to access the redux's store state
    const products = useSelector((state)=>state.amazonReducer.products);
    const [totalPrice, setTotalPrice] = useState('')
    //total price setter. Re-renders any time there is a change in state.amazonReducer.products
    useEffect(()=>{
        let total =0;
        products.map((item)=>{
            total += item.price * item.quantity;
            return setTotalPrice(total.toFixed(2));
        })
    },[products]);

    return (
        <div className='w-full bg-gray-100 p-4'>
            { products.length > 0 ? (
                <div  className='container mx-auto h-auto grid grid-cols-2 mdl:grid-cols-5 mdl:gap-8'>
                    <div  className='w-full h-full bg-white px-4 col-span-4'>
                        <div className='font-titleFont flex items-center justify-between border-b-[1px] border-b-gray-400 py-3'>
                            <h2 className='text-mdl lgl:text-3xl font-normal'>Shopping Cart</h2>
                        </div>
                        <div className='mb-5'>
                            {/*Cart products list. Maps through the products array in the global state to display the items*/}
                            { products.map((item)=> (
                                <div key={item.id} className='w-full border-b-[1px] border-b-gray-300 p-4 flex items-center gap-6'>
                                    <div className='w-1/5'>
                                        <img className='w-full h-44 object-contain' src={item.image} alt='product'/>
                                    </div>
                                    <div className='w-4/5'>
                                        <h2 className='font-semibold text-mdl lgl:text-lg'>{item.title}</h2>
                                        <p className='text-sm hidden lgl:flex'>{item.description}</p>
                                        <p className='text-base'>
                                            Unit Price <span className='font-semibold'>${item.price}</span>
                                        </p>
                                        <div className='bg-[#F0F2F2] flex justify-center items-center gap-1 w-24 py-1 text-center drop-shadow-lg rounded-md'>
                                            <p>Qty:</p>
                                            {/*Cart items quantity counter actions */}
                                            <p
                                                onClick={()=>dispatch(decreseQuantity(item.id))}
                                                className='cursor-pointer bg-gray-200 px-1 rounded-md hover:bg-gray-400 duration-300'>
                                                -
                                            </p>
                                            <p>{item.quantity}</p>
                                            <p
                                                onClick={()=>dispatch(increseQuantity(item.id))}
                                                className='cursor-pointer bg-gray-200 px-1 rounded-md hover:bg-gray-400 duration-300'>
                                                +
                                            </p>
                                        </div>
                                        <button
                                            onClick={()=>dispatch(deleteItem(item.id))}
                                            className='bg-red-500 w-36 py-1 rounded-lg text-white mt-2 hover:bg-red-700 active:bg-red-900 duration-300'>
                                            Delete Item
                                        </button>
                                    </div>
                                    <div>
                                        <p className='text-lg font-titleFont font-semibold'>${item.price * item.quantity}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='w-[full] py-2'>
                            {/*this action resets the products array of the global state */}
                            <button
                                onClick={()=> dispatch(resetCart())}
                                className='px-4 lgl:px-10 py:1 lgl:py-2 bg-red-500 hover:bg-red-600 active:bg-red-500 text-white rounded-lg font-titleFont font-semibold text-base lgl:text-lg tracking-wide'>
                                Clear Cart
                            </button>
                        </div>
                    </div>
                    <div  className='w-[200%] mdl:w-[100%] h-auto lg:h-80 xl:h-52 bg-white flex flex-col xl:justify-center items-center p-4'>
                        <div>
                            <p className='flex lg:gap-2 items-start text-sm'>
                                <span className='bg-white text-green-500 rounded-full'><CheckCircleIcon/></span>
                                Your order quialifies for FREE Shipping Choose this option at checkout. See details...
                            </p>
                        </div>
                        <div>
                            <p className='font-semibold px-10 py-1 flex flex-col items-center justify-between gap-2'>
                                Total:
                                <span className='text-lg font-bold'>${totalPrice}</span>
                            </p>
                        </div>
                        <button className='w-full font-titleFont font-medium text-base bg-gradient-to-tr from-yellow-400 to-yellow-200 border hover:from-yellow-300 hover:to-yellow border-yellow-500 hover:border-yellow-700 active:bg-gradient-to-bl active:from-yellow-400 active:to-yellow-500 duration-200 py-1.5 rounded-md mt-3'>
                            Proceed to checkout
                        </button>
                    </div>
                </div>
            ):(
                /*framer-motion component for translation effect*/
                <motion.div
                    initial={{ y: 70, opacity:0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.5, duration: 0.5 }}
                    className='flex justify-center items-center gap-4 py-10'>
                    <div>
                        <img className='w-80 rounded-lg p-4 mx-auto' src={emptyCart} alt='empty cart'/>
                    </div>
                    <div className='w-96 p-4 bg-white flex flex-col items-center rounded-md shadow-lg'>
                        <h1 className='font-titleFont text-xl font-bold'>Your Cart feels lonely.</h1>
                        <p className='text-sm text-center'>
                            Your Shopping Cart lives to serve. Give it a purpose - fill it with books, electronics, videos, etc. and make it happy.
                        </p>
                        <Link to='/'>
                            <button className='mt-6 bg-yellow-400 rounded-md cursor-pointer hover:bg-yellow-500 active:bg-yellow-700 px-8 py-2 font-titleFont font-semibold text-lg'>
                                Continue Shopping
                            </button>
                        </Link>
                    </div>
                </motion.div>
            )
            }
        </div>
    )
};

export default Cart;